(ns ui.state.session.model
  (:require
   [common.util :as cu]

    ;; TODO remove this once ready 
   [frontend.state.current-session :as session]))

(def root-path [::state])
(def entities-path (conj root-path :entities))


;; Value getters

(defn get-account-id
  [db]
  @session/account-id)

(defn get-account
  [db]
  @session/account)

(defn get-entities
  [db]
  (get-in db entities-path))

(defn get-entity
  [db entity-id]
  (let [entities (get-entities db)
        legacy-entities @session/entities
        entities (merge legacy-entities entities)]
    (get entities entity-id)))


;; value setters

(defn merge-entities
  [db entities-by-id]
  (update-in db entities-path merge entities-by-id))

(defn remove-entities
  [db entity-ids-to-remove]
  (let [prev-entities (get-entities db)
        new-entities (apply dissoc prev-entities entity-ids-to-remove)]
    (assoc-in db entities-path new-entities)))

(defn merge-entity
  [db entity]
  (let [entity-id (:db/id entity)]
    (merge-entities db {entity-id entity})))
